
<template>
	<section>			
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
                <el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="primary" v-on:click="getListData" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="getListData" placeholder="名称"></el-input>
				</el-form-item>
  				<el-form-item >                 
                <el-select  v-model="TenancyId" clearable filterable placeholder="选择或搜索门店"   >
                 <el-option
               v-for="item in optionsShop"
               :key="item.Id"
                  :label="item.Name"
               :value="item.Id">
                  </el-option>
                   </el-select>				 
                </el-form-item>  
               
		
			</el-form>
		</el-col>

		<!--列表-->
		<el-table  :data="List" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width:1702px">
			<el-table-column type="selection" width="55">
			</el-table-column>		
			<el-table-column prop="Name" label="队伍中文全称" width="140" sortable>
			</el-table-column>
 			<el-table-column prop="ShortName" label="队伍中文简称" width="140"  sortable>
			</el-table-column>	        
  			<el-table-column prop="PhoneticName" label="首字母简称" width="140"  sortable>
			</el-table-column>	  
  			<el-table-column prop="Citizenship" label="国籍" width="140"  sortable>
			</el-table-column>	  
  			<el-table-column prop="AreaCode" label="区号" width="120"  sortable>
			</el-table-column>	  
  			<el-table-column prop="TeamType" label="队伍类型" width="120"  sortable>
			</el-table-column>	
   			<el-table-column prop="Unit" label="开票单位名称" width="140"  sortable>
			</el-table-column>
   			<el-table-column prop="TaxNumber" label="税号" width="120"  sortable>
			</el-table-column>
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>

			<!-- <el-table-column label="操作" min-width="40" fixed="right">
				<template  slot-scope="scope">
				</template>
			</el-table-column> -->
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-tag>当前有{{Count}}个队伍</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="Count" style="float:right;">
			</el-pagination>
		</el-col>
  <!-- 重置界面 -->
	</section>
</template>

<script>
	import util from '../../common/js/util'

	import { getTeamList,getShopInfor } from '../../api/api';

	export default {
		data() {
			return {
                optionsShop:[],
                imageVisible:false,
                seeImageVisible:false,
                imgUrl:'',
				filters: {
					Name: '',
					Type:'',				
				},
				fit:'contain',
				CertificateId:'',
				Count:0,
				List:[],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列
                TenancyId:''
			}
		},
		methods: {
           getShopList()
           {
            let para={}
            getShopInfor(para).then((res) => {                  
                    this.optionsShop = res.data;
                    // console.log( this.optionsShop);
				})
				 .catch(error=>{
                 alert('网络错误');
                });          				
           }, 
 //性别显示转换
			formatSex: function (row, column) {
				return row.Sex == 1 ? '男' : row.Sex == 0 ? '女' : '未知';
			},


			formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');
			},

			//性别显示转换
			handleCurrentChange(val) {
				this.page = val;
				this.getListData();
			},

			getListData() {
				// this.getCount();
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
				    TenancyId:this.TenancyId
				};				

				this.listLoading = true;
				//NProgress.start();
				getTeamList(para).then((res) => {
					//在浏览器打印出来可以看到 返回的信息应该怎么点
	
					//结合vsapi写法
					// this.total = res.data.total;
					// this.users = res.data.data;
					//前端mock测试
					console.log(res);					
					this.List =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
					// console.log(res);
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},							

			selsChange: function (sels) {
				this.sels = sels;
			},

   closeDialog(){
		this.inputIdCard="";
      this.onCellClick(event);
    },
   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
		},
		mounted() {
            this.getListData();
            this.getShopList();
			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
.customWidth{
        width:22%;
    }
.el-dialog {
    position: absolute;
    left: 50%;
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    margin-bottom: 50px;
}
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.el-upload-dragger {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100%;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// TeamList.vue?1b8c3c34